module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABECAYAAAA4E5OyAAABOklEQVR4Xu2c0Q2CMBRFW7bQORq2YA1ZSV3DLchjDOkWrWlSE/SD5MaPEjx8GWLS18M9vH684F3ja5qmoeu6WykjpTT2ff9oWZJvuXhZ28yezrlzrSOGEN6/m5S2ByB5vfMQQtOami5eEwKQdSLMDCAA2Xg9kpAvOAAByPZxgoSQEBIiHblRBmVQBmUkAiiDMlJg6DIogzIoIxFAGZSRAkOXQRmUQRmJAMqgjBQYuszelanzGdfVSIL0hA/058V7P3ozW5xzpwNt7JetRIB84ot+nuch51xGmv49JbGMdDEw8yUYQACy/c4lISSEhEjnEpRBGZRBGYkAyqCMFBi6DMqgDMpIBFAGZaTA0GVQBmVQRiKAMigjBYYugzIogzISAZRBGSkwe+gyfFBl/cjqSNe93EspXVp/cucFqooiRmyNgjkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/newCode/imgUploadBox/add.png
// module id = 1271
// module chunks = 2